import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import { UserService } from 'src/app/services/user.service';
import { UsersDataResponse } from '../model/users-data-response';

@Injectable()
export class CurrentUserResolver  {
    public currentUser = new BehaviorSubject(new UsersDataResponse());
    constructor(private userservice: UserService) {
        this.currentUser=new BehaviorSubject(new UsersDataResponse());
    }


    resolve(route: import("@angular/router").ActivatedRouteSnapshot, state: import("@angular/router").RouterStateSnapshot): Observable<any> {
        // this.currentUser=new BehaviorSubject(new UsersDataResponse());
        // this.userservice.getLoginUserData().subscribe(data=>{
        //    this.currentUser.next(data);
        // })
        return  this.userservice.getLoginUserData();
         }
    }
